import React from 'react';
import Progress from './progress';
import ListItem from './list_item';

const Language = ({ data }) => (
  <section>
    <h1 className="section-header">Languages</h1>
    {data.map(language => (
      <div key={language.title} className="my-5">
        <h1 className="item-header font-semibold text-lg mb-2"></h1>
        {language.examples.map(example => (
          <span key={example.name}>
            {language.type === 'percent' && (
              <Progress name={example.name} percent={example.percent} />
            )}
            {language.type === 'tag' && (
              <span key={example.name} className="tag">
                {example.name}
              </span>
            )}
            {language.type === 'list' && (
              <ListItem key={example.name} text={example.name} />
            )}
          </span>
        ))}
      </div>
    ))}
  </section>
);

export default Language;
